/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const SupportPost = {
  id: 'support.post',
  tag: 'Support',
  summary: 'Post support Enquiry',
  description: 'Create a support enquiry',
  method: 'post',
  flags: { isAuthorized: true },
  route: () => `/support/enquiry`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            topic: ZodTypes.TrimmedString.min(1),
            subject: ZodTypes.TrimmedString.min(1),
            message: ZodTypes.TrimmedString.min(1),
            sendConfirmationEmail: z.boolean(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
